// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p class=\"login-message\">\n  Hi, if you are a Weka employee, please login here. If not feel free to navigate to <a href=\"https://www.weka.io\">weka.io</a> or <a href=\"https://docs.weka.io\">docs.weka.io</a>\n</p>\n<div class=\"g-signin2\" data-onsuccess=\"onSignIn\" data-theme=\"dark\"></div>";
},"useData":true});
